import { render, staticRenderFns } from "./informationPage.vue?vue&type=template&id=7e6ab4b0&scoped=true"
import script from "./informationPage.vue?vue&type=script&lang=js"
export * from "./informationPage.vue?vue&type=script&lang=js"
import style0 from "./informationPage.vue?vue&type=style&index=0&id=7e6ab4b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6ab4b0",
  null
  
)

export default component.exports